import { Dispatch } from 'redux';
import { AxiosResponse, AxiosError } from 'axios';
import { executeHttpRequest } from '../epics/api';
import { TApiResponse } from '../types/api';
import { TPayrollFreelancer } from '../components/payments/payroll/types';

export const LOAD_FREELANCERS_PAYROLL = 'LOAD_FREELANCERS_PAYROLL';
export const LOADED_FREELANCERS_PAYROLL_ERROR =
    'LOADED_FREELANCERS_PAYROLL_ERROR';
export const LOADED_FREELANCERS_PAYROLL_SUCCESS =
    'LOADED_FREELANCERS_PAYROLL_SUCCESS';



function toggleFetchPayroll(requestKey: string) {
    return {
        type: LOAD_FREELANCERS_PAYROLL,
        meta: { requestKey },
    };
}

function loadPayroll(
    response: AxiosResponse<TApiResponse<TPayrollFreelancer[]>>,
    requestKey: string,
) {
    return {
        type: LOADED_FREELANCERS_PAYROLL_SUCCESS,
        payload: response.data,
        meta: { requestKey },
    };
}

function loadPayrollFail(message: string, requestKey: string) {
    return {
        type: LOADED_FREELANCERS_PAYROLL_ERROR,
        payload: message,
        meta: { requestKey },
    };
}

export function fetchPayroll(searchParams: URLSearchParams) {
    return (dispatch: Dispatch) => {
        const params = new URLSearchParams(searchParams);
        const requestKey = params.toString();
        dispatch(toggleFetchPayroll(requestKey));
        executeHttpRequest(`freelancers/?${requestKey}`)
            .then((response: AxiosResponse<TApiResponse<TPayrollFreelancer[]>>) => {
                dispatch(loadPayroll(response, requestKey));
            })
            .catch((error: AxiosError) => {
                if (error.response) {
                    dispatch(
                        loadPayrollFail(
                            `Oops, something went wrong. Status code ${error.response.status}`,
                            requestKey,
                        ) as any,
                    );
                } else {
                    dispatch(
                        loadPayrollFail('Oops, something went wrong', requestKey),
                    );
                }
            });
    };
}


